export const PROJECT_SELECTION_MAIN_PROJECTS = [
  'jobConfiguration',
  'projectSelection',
  'mainProjects',
];
export const PROJECT_SELECTION_SUB_PROJECTS = [
  'jobConfiguration',
  'projectSelection',
  'subProjects',
];
export const MODEL_SELECTION_FILTERS = [
  'jobConfiguration',
  'modelSelection',
  'filters',
];
export const MODEL_SELECTION_RELEASES = [
  'jobConfiguration',
  'modelSelection',
  'releases',
];
export const MODEL_SELECTION_SELECTED_RELEASE = [
  'jobConfiguration',
  'modelSelection',
  'selectedRelease',
];
export const TARGET_SELECTION_TARGETS = [
  'jobConfiguration',
  'targetSelection',
  'targets',
];
export const TARGET_SELECTION_SELECTED_TARGET = [
  'jobConfiguration',
  'targetSelection',
  'selectedTarget',
];

export const TEST_CONFIGURATION_MAIN_SETTINGS_INTERACTIVE = [
  'jobConfiguration',
  'testConfiguration',
  'fields',
  'mainSettings',
  'interactive',
  'value',
];
export const TEST_CONFIGURATION_MAIN_SETTINGS_HSLE = [
  'jobConfiguration',
  'testConfiguration',
  'fields',
  'mainSettings',
  'hsle',
  'value',
];
export const TEST_CONFIG_TEST_OBJECT_TYPE = [
  'jobConfiguration',
  'testConfiguration',
  'fields',
  'testContent',
  'testObject',
  'value',
];

export const TEST_CONFIG_DYNAMIC_FIELDS = [
  'jobConfiguration',
  'testConfiguration',
  'dynamicFields',
];
export const TEST_CONFIG_FIELDS = [
  'jobConfiguration',
  'testConfiguration',
  'fields',
];

export const TEST_CONFIG_FUSES = [
  'jobConfiguration',
  'testConfiguration',
  'fuses',
];
export const TEST_CONFIG_STRAPS = [
  'jobConfiguration',
  'testConfiguration',
  'straps',
];

export const TEST_CONFIG_TIMEOUT_VALUE = [
  'jobConfiguration',
  'testConfiguration',
  'fields',
  'mainSettings',
  'timeout',
  'value',
];
export const TEST_CONFIG_SEED_VALUE = [
  'jobConfiguration',
  'testConfiguration',
  'fields',
  'mainSettings',
  'seed',
  'value',
];
export const TEST_CONFIG_OBJ_PATH_VALUE = [
  'jobConfiguration',
  'testConfiguration',
  'fields',
  'testContent',
  'objPath',
  'value',
];
export const TEST_CONFIG_PSF_VALUE = [
  'jobConfiguration',
  'testConfiguration',
  'fields',
  'testContent',
  'psfFiles',
  'value',
];
export const TEST_CONFIG_SLN_VALUE = [
  'jobConfiguration',
  'testConfiguration',
  'fields',
  'testContent',
  'slnFiles',
  'value',
];
export const TEST_CONFIG_PLATFORM_CONFIG_VALUE = [
  'jobConfiguration',
  'testConfiguration',
  'fields',
  'testContent',
  'platformConfigPath',
  'value',
];
export const TEST_CONFIG_ACTION_NAME_VALUE = [
  'jobConfiguration',
  'testConfiguration',
  'fields',
  'testContent',
  'actionName',
  'value',
];
export const TEST_CONFIG_PRE_COMMANDS_VALUE = [
  'jobConfiguration',
  'testConfiguration',
  'fields',
  'commands',
  'preCommands',
  'value',
];
export const TEST_CONFIG_POST_COMMANDS_VALUE = [
  'jobConfiguration',
  'testConfiguration',
  'fields',
  'commands',
  'postCommands',
  'value',
];

export const TOTAL_COUNT = ['genericTable', 'totalCount'];
export const CLICKED_PAGES_ARRAY = ['genericTable', 'clickedPagesArray'];
// export const SELECTED_ROW = ['genericTable', 'selectedRow'];

export const USER_DATA = ['userData'];
export const USER_NAME = ['userData', 'idsid'];

export const USER_PERMISSIONS = ['userPermissions'];

export const generateTestConfigDynamicSelector = (category, field) => {
  return [
    'jobConfiguration',
    'testConfiguration',
    'dynamicFields',
    category,
    'testFields',
    field,
    'value',
  ];
};

export const DASHBOARD_RECENT_EPR = ['dashboard', 'EPR'];
export const DASHBOARD_EPR_TARGETS = ['dashboard', 'EPRTargets'];
export const DASHBOARD_NB_JOBS = ['dashboard', 'NBJobs'];
export const DASHBOARD_RECENT_PPR = ['dashboard', 'PPR'];
export const DASHBOARD_NB_JOBS_REFRESH = ['dashboard', 'refresh'];

export const EXTERNAL_WINDOWS = ['netbatchJobs', 'externalWindows'];
export const CURRENT_SESSION_JOBS = ['netbatchJobs', 'currentSessionJobs'];
